/* bristm-contact — section script (loaded only where the section renders) */
(function () {
  function initContact(scope) {
    var forms = (scope || document).querySelectorAll('[data-b-contact-form]');
    Array.prototype.forEach.call(forms, function (form) {
      if (form.dataset.bBound) return;
      form.dataset.bBound = '1';

      var boxes = form.querySelectorAll('[data-b-contact-interest]');
      var hidden = form.querySelector('[data-b-contact-interests]');
      if (hidden && boxes.length) {
        /* With JS: send one joined field instead of repeated checkbox names */
        Array.prototype.forEach.call(boxes, function (box) {
          box.removeAttribute('name');
        });
        hidden.disabled = false;
        var sync = function () {
          var values = [];
          Array.prototype.forEach.call(boxes, function (box) {
            if (box.checked) values.push(box.value);
          });
          hidden.value = values.join(', ');
        };
        form.addEventListener('change', sync);
        sync();
      }

      form.addEventListener(
        'invalid',
        function (e) {
          if (e.target.classList) e.target.classList.add('is-invalid');
        },
        true
      );
      form.addEventListener('input', function (e) {
        var t = e.target;
        if (t.classList && t.classList.contains('is-invalid') && t.checkValidity()) t.classList.remove('is-invalid');
      });

      var notice = form.querySelector('[data-b-contact-notice]');
      if (notice) {
        requestAnimationFrame(function () {
          notice.focus({ preventScroll: true });
          notice.scrollIntoView({ block: 'center' });
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initContact(document);
    });
  } else {
    initContact(document);
  }
  document.addEventListener('shopify:section:load', function (e) {
    initContact(e.target);
  });
})();
